import { AdditionalRateType } from 'src/app/recruiting/locums-margin-calculator/models/additional-rate-type.model';
import { AdditionalRate } from 'src/app/recruiting/locums-margin-calculator/models/additional-rate.model';
import { MarginCoverageType } from 'src/app/recruiting/locums-margin-calculator/models/margin-coverage-type.model';

export interface AdditionalRatesSlice {
    readonly additionalRateTypes: AdditionalRateType[];
    readonly marginCoverageTypes: MarginCoverageType[];
    readonly additionalRates: AdditionalRate[];
}

export const initialAdditionalRatesSlice: AdditionalRatesSlice = {
    additionalRateTypes: [],
    marginCoverageTypes: [],
    additionalRates: []
};
